import { render, staticRenderFns } from "./ProteinItem.vue?vue&type=template&id=1f29201e&scoped=true&"
import script from "./ProteinItem.vue?vue&type=script&lang=js&"
export * from "./ProteinItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29201e",
  null
  
)

export default component.exports